(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[40642,65250],{

/***/ 40642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BestZantacLawyersWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/styles/variables/bestzantaclawyersVariables.module.scss
var bestzantaclawyersVariables_module = __webpack_require__(47312);
var bestzantaclawyersVariables_module_default = /*#__PURE__*/__webpack_require__.n(bestzantaclawyersVariables_module);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/bestzantaclawyers/logo/index.tsx


function BestZantaclawyersLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "321",
        height: "35",
        fill: "none",
        viewBox: "0 0 321 35",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2_459)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#4C98B1",
                        d: "M31.416 28.942V7.358h8.696a8.431 8.431 0 013.546.707 5.39 5.39 0 012.386 2.083c.562.909.847 1.961.82 3.029a4.692 4.692 0 01-.353 1.805c-.22.573-.544 1.1-.96 1.552a3.71 3.71 0 01-1.337.96c.704.213 1.349.589 1.88 1.098a5.617 5.617 0 011.338 1.88c.317.738.48 1.532.48 2.335a5.995 5.995 0 01-.909 3.345 5.932 5.932 0 01-2.524 2.133 8.216 8.216 0 01-3.471.72l-9.593-.063zm8.38-12.811a3.042 3.042 0 001.477-.354c.424-.223.78-.554 1.035-.96.251-.405.383-.873.379-1.35a2.613 2.613 0 00-.341-1.262 2.524 2.524 0 00-.985-.921 3.092 3.092 0 00-1.464-.341h-4.354v5.238l4.253-.05zm.896 9.302a3.08 3.08 0 001.566-.392 2.65 2.65 0 001.072-1.098c.258-.49.388-1.037.379-1.59a2.903 2.903 0 00-.404-1.515 3.004 3.004 0 00-1.148-1.098 3.344 3.344 0 00-1.704-.416h-4.898v6.109h5.137zM53.87 22.214a4.518 4.518 0 001.653 2.701 4.733 4.733 0 002.991.985 5.427 5.427 0 003.787-1.477l1.88 2.714a8.457 8.457 0 01-2.65 1.653 9.19 9.19 0 01-3.282.58 8.166 8.166 0 01-7.156-4.19 8.696 8.696 0 01-1.073-4.228 8.975 8.975 0 011.022-4.253 7.763 7.763 0 012.815-3.068 7.573 7.573 0 014.039-1.123 8.278 8.278 0 014.279 1.06 6.954 6.954 0 012.726 2.967 10.463 10.463 0 01.846 5.68H53.87zm1.514-5.427a4.316 4.316 0 00-1.49 2.448h8.142a4.317 4.317 0 00-1.389-2.524 3.988 3.988 0 00-2.612-.858 4.102 4.102 0 00-2.65.934zM70.745 28.727a12.004 12.004 0 01-3.32-1.78l1.856-2.764c.784.527 1.632.951 2.524 1.262a8.13 8.13 0 002.764.505 3.548 3.548 0 001.855-.404 1.263 1.263 0 00.682-1.173 1.149 1.149 0 00-.353-.859 3.243 3.243 0 00-1.124-.656 13.96 13.96 0 00-2.133-.644 9.239 9.239 0 01-3.786-1.83 3.9 3.9 0 01-1.44-3.117c-.01-.87.26-1.72.77-2.424a5.188 5.188 0 012.222-1.716 8.494 8.494 0 013.459-.644c1.06.01 2.113.189 3.117.53 1.045.333 2.03.831 2.916 1.477l-1.894 2.79a8.911 8.911 0 00-2.057-.948 7.248 7.248 0 00-2.26-.403 3.383 3.383 0 00-1.741.366 1.148 1.148 0 00-.593 1.022c-.002.28.101.55.29.757.287.278.632.49 1.01.619a17.9 17.9 0 001.994.618c1.029.238 2.028.59 2.979 1.048a5.048 5.048 0 011.918 1.59c.484.704.727 1.545.694 2.398a4.443 4.443 0 01-.795 2.525 5.3 5.3 0 01-2.259 1.792 7.976 7.976 0 01-3.332.656 11.6 11.6 0 01-3.963-.593zM88.1 28.942h-3.938V16.459h-2.298v-3.635h2.285V9.037l3.95-.934v4.771h3.547v3.585H88.1v12.483z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F38620",
                        d: "M109.998 28.942H93.009v-3.093l11.171-14.73H93.211V7.334h16.497v2.89L98.412 25.156h11.586v3.787zM124.955 12.849h3.408v16.093h-3.421l-.277-1.894a6.81 6.81 0 01-2.171 1.666 6.236 6.236 0 01-2.777.606 7.79 7.79 0 01-4.052-1.123 8.455 8.455 0 01-2.953-3.055 8.552 8.552 0 01-1.086-4.24 8.47 8.47 0 014.052-7.283 7.575 7.575 0 014.039-1.123 6.314 6.314 0 012.815.605 6.746 6.746 0 012.171 1.692l.252-1.944zm-2.524 12.155a4.432 4.432 0 001.666-1.679 4.665 4.665 0 00.618-2.398 4.749 4.749 0 00-.618-2.424 4.382 4.382 0 00-1.666-1.69 4.518 4.518 0 00-2.335-.62 4.458 4.458 0 00-3.951 2.31 5.23 5.23 0 000 4.835 4.341 4.341 0 001.641 1.666c.7.409 1.499.618 2.31.605a4.632 4.632 0 002.297-.605h.038zM144.935 13.316a5.46 5.46 0 012.221 2.373 8.13 8.13 0 01.783 3.786v9.53h-3.925v-8.836a4.343 4.343 0 00-.934-2.953 3.285 3.285 0 00-2.588-1.035 4.103 4.103 0 00-2.007.517 3.96 3.96 0 00-1.438 1.414 3.788 3.788 0 00-.531 1.97v8.923h-3.912V12.849h3.357l.265 2.082a6.424 6.424 0 012.36-1.767 7.043 7.043 0 012.979-.669 6.538 6.538 0 013.37.82zM156.004 28.942h-3.938V16.459h-2.309v-3.635h2.309V9.037l3.951-.934v4.771h3.547v3.585h-3.547l-.013 12.483zM173.952 12.849h3.358v16.093h-3.421l-.277-1.894a6.763 6.763 0 01-2.159 1.666 6.309 6.309 0 01-2.776.606 7.711 7.711 0 01-3.989-1.123 8.26 8.26 0 01-2.953-3.055 8.705 8.705 0 010-8.469 8.288 8.288 0 012.953-3.054 7.574 7.574 0 014.039-1.123 6.4 6.4 0 012.815.605 6.89 6.89 0 012.171 1.692l.239-1.944zm-2.524 12.155a4.562 4.562 0 001.679-1.68c.409-.731.618-1.559.606-2.397a4.874 4.874 0 00-.606-2.424 4.581 4.581 0 00-4.014-2.31 4.39 4.39 0 00-2.297.62c-.693.4-1.261.985-1.641 1.69a5.122 5.122 0 000 4.834c.376.698.94 1.275 1.628 1.667.702.406 1.5.615 2.31.605a4.603 4.603 0 002.297-.605h.038zM184.693 28.247a8.18 8.18 0 01-3.016-3.067 8.705 8.705 0 010-8.469 8.341 8.341 0 013.029-3.08 8.205 8.205 0 014.266-1.136 8.835 8.835 0 013.244.581c.967.384 1.856.94 2.625 1.64l-1.969 2.816a6.318 6.318 0 00-1.678-1.073 5.23 5.23 0 00-1.982-.366 4.579 4.579 0 00-2.36.643 4.684 4.684 0 00-1.717 1.755 4.9 4.9 0 00-.631 2.524c-.02.885.203 1.758.644 2.524a4.77 4.77 0 001.729 1.742 4.595 4.595 0 002.335.631 5.051 5.051 0 001.982-.492 6.472 6.472 0 001.729-1.06l1.944 2.802a8.229 8.229 0 01-2.626 1.628c-1.03.398-2.126.6-3.231.593a8.27 8.27 0 01-4.317-1.136z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#4C98B1",
                        d: "M212.045 28.942h-14.149V7.358h4.165v17.608h9.984v3.976zM227.14 12.849h3.408v16.093h-3.42l-.278-1.894a6.8 6.8 0 01-2.171 1.666 6.309 6.309 0 01-2.777.606 7.786 7.786 0 01-4.051-1.123 8.632 8.632 0 01-2.941-11.524 8.363 8.363 0 012.953-3.054 7.575 7.575 0 014.039-1.123 6.311 6.311 0 012.815.605 6.746 6.746 0 012.171 1.692l.252-1.944zm-2.524 12.155a4.432 4.432 0 001.666-1.679 4.656 4.656 0 00.618-2.398 4.739 4.739 0 00-.618-2.424 4.382 4.382 0 00-1.666-1.69 4.518 4.518 0 00-2.335-.62 4.458 4.458 0 00-3.951 2.31 5.229 5.229 0 000 4.835 4.348 4.348 0 001.641 1.666c.7.409 1.499.618 2.31.605a4.632 4.632 0 002.297-.605h.038zM249.758 24.499l4.191-11.675h4.266l-6.311 16.117h-3.635l-2.726-7.055-2.6 7.056h-3.787l-6.311-16.118h4.191l3.988 11.675 3.787-11.675h4.177l-1.792 4.796 2.562 6.879zM267.038 34.394h-4.178l2.272-5.49-6.488-16.08h4.279l4.14 11.523 4.165-11.523h4.329l-8.519 21.57zM280.151 22.214a4.523 4.523 0 001.654 2.701 4.732 4.732 0 002.991.985 5.43 5.43 0 003.787-1.477l1.88 2.714a8.459 8.459 0 01-2.65 1.653 9.195 9.195 0 01-3.282.58 8.17 8.17 0 01-7.219-4.19 8.69 8.69 0 01-1.073-4.228 9.115 9.115 0 011.009-4.253 7.894 7.894 0 012.828-3.068 7.571 7.571 0 014.039-1.123 8.275 8.275 0 014.278 1.06 6.952 6.952 0 012.727 2.967 10.457 10.457 0 01.845 5.68h-11.814zm1.515-5.427a4.375 4.375 0 00-1.489 2.448h8.204a4.313 4.313 0 00-1.389-2.524 3.986 3.986 0 00-2.612-.858 4.103 4.103 0 00-2.714.934zM305.092 12.824a7.298 7.298 0 011.843.946l-1.742 3.194a4.165 4.165 0 00-2.449-.846 3.043 3.043 0 00-1.691.555c-.543.4-.977.93-1.262 1.54a5.453 5.453 0 00-.53 2.297v8.431h-3.913V12.85h3.357l.278 2.158a5.048 5.048 0 011.78-1.843 4.692 4.692 0 012.524-.656c.614.01 1.223.117 1.805.316zM310.002 28.727a12.195 12.195 0 01-3.32-1.78l1.894-2.764a11.05 11.05 0 002.524 1.262c.885.328 1.82.499 2.764.505a3.545 3.545 0 001.855-.404 1.26 1.26 0 00.682-1.174 1.147 1.147 0 00-.353-.858 3.13 3.13 0 00-1.124-.656 13.932 13.932 0 00-2.133-.644 9.322 9.322 0 01-3.786-1.83 3.893 3.893 0 01-1.439-3.117c-.011-.87.259-1.72.77-2.424a5.184 5.184 0 012.221-1.716 8.493 8.493 0 013.458-.644 9.985 9.985 0 013.118.53c1.004.34 1.95.834 2.802 1.464l-1.868 2.802a8.919 8.919 0 00-2.057-.947 7.203 7.203 0 00-2.26-.403 3.381 3.381 0 00-1.741.366 1.148 1.148 0 00-.594 1.022c-.002.28.102.55.291.757.287.278.632.49 1.009.619.653.243 1.319.45 1.995.618 1.028.238 2.027.59 2.978 1.048a5.048 5.048 0 011.919 1.59 3.96 3.96 0 01.694 2.398 4.442 4.442 0 01-.795 2.525 5.301 5.301 0 01-2.259 1.792 7.98 7.98 0 01-3.332.656 11.703 11.703 0 01-3.913-.593zM8.886 30.81a6.31 6.31 0 01-1.338-3.787v-10.69c.609-.324 1.237-.611 1.88-.859a20.588 20.588 0 017.207-1.262 21.182 21.182 0 014.658.505v-.631a5.474 5.474 0 00-.126-1.262l-.19-.682a5.818 5.818 0 00-5.503-3.925V5.692h1.805a1.023 1.023 0 001.023-1.022V2.461A2.525 2.525 0 0015.777 0H5.87a2.524 2.524 0 00-2.524 2.461v2.234a1.022 1.022 0 001.022 1.023h1.628v2.524h-.29a5.819 5.819 0 00-5.819 5.819v14.716a4.317 4.317 0 004.317 4.317h6.778a12.442 12.442 0 01-2.095-2.284zM4.48 5.1a.34.34 0 01-.341-.342V2.461A1.792 1.792 0 015.932.681h9.908a1.78 1.78 0 011.78 1.78v2.234a.34.34 0 01-.34.341L4.48 5.1z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F38620",
                        d: "M21.558 22.467l-5.92 5.92-3.483-3.484 1.363-1.376 2.12 2.12 4.557-4.556 1.363 1.376z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F38620",
                        d: "M16.85 15.828a14.49 14.49 0 00-8.053 2.133v8.734C8.797 32.059 16.85 35 16.85 35s8.053-2.94 8.053-8.305V17.96a14.44 14.44 0 00-8.053-2.133zm5.806 13.694a10.313 10.313 0 01-2.524 2.335 18.482 18.482 0 01-3.333 1.83 20.372 20.372 0 01-3.357-1.855 10.704 10.704 0 01-2.524-2.322 4.784 4.784 0 01-1.01-2.815v-8.053c.459-.24.93-.456 1.414-.643a15.953 15.953 0 0110.83 0c.484.182.956.397 1.413.643v8.053a4.746 4.746 0 01-.909 2.827z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2_459",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H320.288V35H0z"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/bestzantaclawyersWrapper.tsx









const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});

const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
function BestZantacLawyersWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails: { region  } ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Zantac",
                    domain: "BestZantacLawyers.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Zantac",
                    domain: "BestZantacLawyers.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        textColor: (bestzantaclawyersVariables_module_default()).orange,
                        iconColor: (bestzantaclawyersVariables_module_default()).blue,
                        slogan: `find the best zantac lawyers ${region ? `in ${region}` : ""}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BestZantaclawyersLogo, {})
                    }),
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 47312:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blue":"#4c98b1","blueLight":"#e9f9ff","orange":"#f38620","grey":"#7d7d7d","greyLight":"#f3f3f3"};

/***/ })

}]);